import React from 'react'
import './footer.css'

const Footer = () => {
    return (
        <footer className='footer'>
            <div className='footer__container container'>
                <h1 className='footer__title'>Krafox</h1>

                <ul className='footer__list'>
                    <li>
                        <a href="#" className="footer__link">Inicio</a>
                    </li>

                    <li>
                        <a href="#services" className="footer__link">Servicios</a>
                    </li>

                    <li>
                        <a href="#portfolio" className="footer__link">Proyectos</a>
                    </li>
                </ul>

                <div className="footer__social">
                    <a
                        href="#"
                        className="footer__social-link"
                        target='_blank'
                    >
                        <i className='bx bxl-instagram'></i>
                    </a>

                    <a
                        href="#"
                        className="footer__social-link"
                        target='_blank'
                    >
                        <i className='bx bxl-linkedin'></i>
                    </a>

                    <a
                        href="#"
                        className="footer__social-link"
                        target='_blank'
                    >
                        <i className='bx bxl-github'></i>
                    </a>
                </div>
                <span className='footer__copy'>
                    &#169; 2026 Krafox. Todos los derechos reservados.
                </span>
            </div>
        </footer>
    )
}

export default Footer
